// Google Analytics 4 (gtag.js) — helper central. ID é público por natureza (vai no bundle).
const GA_ID = "G-7MKG7Z3XR5";

export function trackPageView(location) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${location.pathname}${location.search}${location.hash}`,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, {
    ...params,
    ...(process.env.NODE_ENV !== "production" ? { debug_mode: true } : {}),
  });
}

export function updateAnalyticsConsent(analyticsGranted) {
  if (typeof window.gtag !== "function") return;
  const value = analyticsGranted ? "granted" : "denied";
  window.gtag("consent", "update", {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
}

export { GA_ID };
